import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { orderQueryOptions } from '@/features/orders';
import { ReturnDetailPage, returnQueryOptions } from '@/features/returns';
import { storeQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/s/$storeId/returns/$returnId')({
  staticData: { tours: ['returns.detail'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.read');
  },
  loader: async ({ context, params }) => {
    const ret = await context.queryClient.query({
      ...returnQueryOptions(params.storeId, params.returnId),
      staleTime: 'static',
    });
    await Promise.all([
      context.queryClient
        .query({ ...orderQueryOptions(params.storeId, ret.orderId), staleTime: 'static' })
        .catch(() => undefined),
      context.queryClient
        .query({ ...storeQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    return { crumb: ret.rmaNumber };
  },
  component: ReturnDetailPage,
});
